import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=9ece2816&scoped=true&lang=pug"
import script from "./basic.vue?vue&type=script&lang=ts"
export * from "./basic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ece2816",
  null
  
)

export default component.exports